import axios from 'CanExConfig/axios'

const endpoint = '/api/candidate/static/job_roles'

export const getStaticJobRoles = async () => {
  const response = await axios(endpoint, {
    method: 'GET',
  })

  return response.data
}
